/* istanbul ignore file */

import { isNotProduction as checkIfNotProduction } from 'src/utils/isNotProduction';

export const useDevToolPermissions = () => {
  const isNotProduction = checkIfNotProduction();

  return isNotProduction !== undefined && isNotProduction;
};
